/* eslint-disable react/jsx-props-no-spreading */
import { Icon, TextField } from '@nike/eds';
import PropTypes from 'prop-types';
import React from 'react';

import './text-input.css';

const CUSTOM_PROPS = ['labelAlwaysVisible', 'hideClearButton', 'onClear'];

/** This is a custom textfield which shows floating label when the textfield contains value */
function TextInput(props) {
  const {
 value, labelAlwaysVisible, hideClearButton, onClear, label, hasErrors
} = props;
  const shouldShowLabel = (labelAlwaysVisible && !!label) || (!!label && !!value);

  const styles = {
    padding: shouldShowLabel ? '0 2px 0 2px' : '0px',
    zIndex: shouldShowLabel ? 1 : 0
  };
  return (
    <div className="text-input">
      <p className={`floating-label ${hasErrors ? 'error' : ''}`} style={styles}>{shouldShowLabel ? label : <>&nbsp;</>}</p>
      <TextField
        {...Object.fromEntries(Object.entries(props).filter(([key]) => !CUSTOM_PROPS.includes(key)))}
        afterSlot={hideClearButton || !value || !onClear ? null : <Icon name="Close" size="m" onClick={onClear} />}
        label={null}
      />
    </div>
  );
}

TextInput.defaultProps = {
  hasErrors: false,
  hideClearButton: false,
  label: null,
  labelAlwaysVisible: false,
  onClear: null,
  value: ''
};

TextInput.propTypes = {
  hasErrors: PropTypes.bool,
  hideClearButton: PropTypes.bool,
  label: PropTypes.string,
  labelAlwaysVisible: PropTypes.bool,
  onClear: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default TextInput;
